<template>
  <div>
    <p class="text-body whitespace-pre-wrap">{{ body }}</p>
  </div>
</template>

<script lang="ts">
export default {
  name: 'MessageBubbleBody',
  props: {
    body: {
      type: String,
      default: '',
    },
  },
};
</script>
